<template>
  <b-modal
    :active.sync="showModal"
    trap-focus
    aria-role="dialog"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form @submit.prevent="passes(addToCart)">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">Add to Collection</p>
          </header>
          <section class="modal-card-body">
            <ValidationProvider
              v-slot="{ errors }"
              name="Collection"
              rules="required"
            >
              <b-field
                label="Collection"
                :type="{ 'is-danger': errors.length > 0 }"
                :message="errors[0]"
              >
                <b-select v-if="!newList" v-model="collection" :expanded="true">
                  <option
                    v-for="item in collections"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </b-select>
                <b-input v-if="newList" v-model="collectionName" />
              </b-field>
              <a v-if="!newList" href="" @click.prevent="addNewList"
                >Add New List</a
              >
              <a v-if="newList" href="" @click.prevent="newList = false"
                >Cancel</a
              >
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="Budget"
              rules="required"
            >
              <b-field
                class="has-margin-top-15"
                label="Add your budget for this title?"
                :type="{ 'is-danger': errors.length > 0 }"
                :message="errors[0]"
              >
                <div class="columns">
                  <div class="column">
                    <b-input
                      v-model="budget"
                      type="number"
                      icon="currency-usd"
                      required
                    />
                  </div>
                  <div class="column" style="padding-top: 18px">
                    {{
                      item.media_type === 'series' || itemType === 'package'
                        ? 'per hour'
                        : 'per title'
                    }}
                  </div>
                </div>
              </b-field>
            </ValidationProvider>
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" @click="closeModal">
              Cancel
            </button>
            <button
              class="button is-primary"
              :loading="loading"
              @click.prevent="passes(addToCart)"
            >
              Add
            </button>
          </footer>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import CartApi from '@/api/cart'
import CollectionApi from '@/api/collections'

export default {
  name: 'AddToCartModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    },
    itemType: {
      type: String,
      default: 'media'
    }
  },
  data() {
    return {
      loading: false,
      showModal: this.show,
      budget: 0,
      newList: false,
      collectionName: '',
      collection: null,
      collections: []
    }
  },
  watch: {
    show() {
      this.showModal = this.show
    }
  },
  async created() {
    this.collections = await CollectionApi.getAll()
  },
  methods: {
    addNewList() {
      this.collectionName = ''
      this.collection = null
      this.newList = true
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    },
    saveCart() {
      const item = {
        budget: this.budget,
        collectionId: this.collection
      }
      if (this.itemType === 'media') {
        item.mediaId = this.item.id
      } else {
        item.packageId = this.item.id
      }
      CartApi.add(item)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Title added successfully',
            position: 'is-top',
            type: 'is-success'
          })
          this.closeModal()
          this.loading = false
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: 'Error adding to your collection',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    },
    addToCart() {
      this.loading = true
      if (this.collection) {
        this.saveCart()
      } else {
        CollectionApi.create({
          name: this.collectionName
        }).then(response => {
          this.collection = response.collectionId
          this.saveCart()
        })
      }
    }
  }
}
</script>
